import axios from 'axios';

// 固定使用 3001 端口访问 API
// 开发环境: localhost:3000 → localhost:3001
// 生产环境: www.abc.com:65534 → www.abc.com:3001
const api = axios.create({
  baseURL: window.location.protocol + '//' + window.location.hostname + ':3001/api',
  timeout: 7200000, // 2小时超时，用于大批量图书扫描和导入
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 检查是否是登录或注册请求，如果是则不自动跳转
    const isAuthRequest = error.config?.url?.includes('/auth/');
    
    if (error.response?.status === 401 && !isAuthRequest) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
